export default "__VITE_ASSET__BaXNBV6a__"